import { createSlice } from "@reduxjs/toolkit";
import type { PayloadAction } from "@reduxjs/toolkit";
import type { EAvailableFaceLanguages } from "@litres/utils";
import { addHydrateReducer } from "../../utils/hydrateReducer";

interface IFaceState {
  language: EAvailableFaceLanguages | null;
  host?: string | null;
}

const initialState: IFaceState = {
  language: null,
  host: null,
};

export const faceSlice = createSlice({
  name: "global/face",
  initialState,
  reducers: {
    setFaceLang: (
      state: IFaceState,
      action: PayloadAction<EAvailableFaceLanguages>
    ) => {
      state.language = action.payload;
    },
    setFaceHost: (state: IFaceState, action: PayloadAction<string>) => {
      state.host = action.payload;
    },
  },
  extraReducers: builder => {
    addHydrateReducer(builder, "face");
  },
});

export const { setFaceLang, setFaceHost } = faceSlice.actions;

export default faceSlice.reducer;
